import { Block, Box, Button, Columns, Container, Form, Heading, Icon, Level, Message, Navbar, Notification, Tile } from 'react-bulma-components';
import React, { forwardRef, useEffect, useImperativeHandle, useRef, useState } from 'react';
import { faHandPointer, faPaintRoller } from '@fortawesome/free-solid-svg-icons'

import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import _ from 'lodash';
import { chordColors } from './score';
import { renderToString } from 'react-dom/server';

const { Checkbox, Control, Field, Input, Label, Textarea } = Form;

const ScoreMarks = forwardRef(({ values, statePrefix, handleChange, songSheetCursor, display }, ref) => {
  const aboveRef = useRef(null);
  const belowRef = useRef(null);
  useImperativeHandle(ref, () => ({
    getEvents() {
      return {
        onChordClick: onChordClick
      };
    },
    getCursor() {
      return {
        cursor
      };
    }
  }));
  const [chordPos, setChordPos] = useState();
  const [chordHtml, setChordHtml] = useState();
  const [mark, setMark] = useState();
  //const [cursor, setCursor] = useState('pointer');
  const cursor = songSheetCursor.songSheetCursor;
  const setCursor = (cursorValue) => songSheetCursor.setSongSheetCursor(cursorValue);
  const [currentColor, setCurrentColor] = useState(null);

  // let mark = _.find(values, { pos: markId });

  const onChordClick = (data) => {

    setChordPos(data.pos);
    // remove data-above attribute
    let children = [];
    data.chord.forEach( element => { 
      if(element !== ""){
        children.push(renderToString(element).replace(/data-above/,'data-dummy'));
      }
    });
    setChordHtml(children);
    setMark(_.find(values, { pos: data.pos }));
  }
  useEffect(() => {
    if(cursor==='roller'){
      setColorFromRoller(currentColor);
    }
    if(cursor==='pointer'){
      setCurrentColor(mark?.bc||'')
    }
  }, [mark]);

  const setColorFromRoller = (color) => {
    setColor(color, true);
  }
  const setColor = (color, keepRollerFocus) => {
    if(!keepRollerFocus){
      setCursor('pointer');
    }
    var event = new Object();
      event.target = {
        name: 'bc',
        value: color
      }
      setCurrentColor(color)
      setValue(event);
  }

  const clearAllMarks = () => {
    var e = new Object();
    e.target = {
      name: `${statePrefix}.scoremarks`,
      value: []
    };
    handleChange(e);
    setMark(undefined);
  }

  const clearMark = () => {
    setCurrentColor('');
    setCursor('pointer');
    //var arr = _.get(values, "scoremarks");
    const result = [...values];
    let markIndex = _.findIndex(result, { pos: chordPos });
    let i = result.splice(markIndex, 1)[0];
    var e = new Object();
    e.target = {
      name: `${statePrefix}.scoremarks`,
      value: result
    };
    handleChange(e);
    setMark(undefined);
  }

  const setValue = (e, type) => {
    if(chordPos===undefined){ return; }
    var event = new Object();
    if (mark) {
      let markIndex = _.findIndex(values, { pos: chordPos });
      event.target = {
        name: `${statePrefix}.scoremarks.${markIndex}.${e.target.name}`,
        value: e.target.value,
        checked: e.target.checked
      }
      handleChange(event, type);
    }
    else {
      const arr = [...values];
      let newmark = {
        pos: chordPos
      };
      newmark[`${e.target.name}`] = type === "Boolean" ? (e.target.checked ? true : false) : e.target.value;
      arr.push(newmark);
      let result = _.sortBy(arr, [function (o) { return _.toNumber(_.replace(o.pos, ':', '.')); }]);
      event.target = {
        name: `${statePrefix}.scoremarks`,
        value: result
      };
      setMark(_.find(result, { pos: chordPos }));
      handleChange(event);
    }

  }
  function pasteTemplateAbove() {
    const aboveInput = aboveRef.current;
    let snippet = "<C: Bb: Eb:>";
    aboveInput.setRangeText(snippet)
    aboveRef.current.selectionStart = aboveRef.current.selectionEnd = aboveRef.current.selectionStart;
    aboveRef.current.focus();
  }
  function pasteTemplateBelow() {
    const belowInput = belowRef.current;
    let snippet = "<C: Bb: Eb:>";
    belowInput.setRangeText(snippet)
    belowRef.current.selectionStart = belowRef.current.selectionEnd = belowRef.current.selectionStart;
    belowRef.current.focus();
  }

  return (
    <>
      <Navbar  active={true} fixed="bottom" style={{ backgroundColor: 'whitesmoke', borderTop: '1px solid #363636', display: display?'inline':'none' }}>
        <Navbar.Menu>
          <Navbar.Container>
            <Box >
              <Level>
                <Level.Side>
                  <Level.Item>
                  <Button
                    color=""
                    renderAs="span"
                    marginless={true}
                    size={'small'}
                    onClick={() => pasteTemplateAbove()}
                    >
                    <b>&lt;&gt;</b>
                  </Button>
                    <Input domRef={aboveRef} size={'small'} style={{ minWidth: 200 }} onChange={(e) =>  {setValue(e); setCursor('pointer');}} name="a" type="text" placeholder="Text above chord" value={mark?.a ?? ""} />
                  </Level.Item>
                  <Level.Item>
                    <Heading className={`is-size-6-mobile is-size-5-tablet is-size-5-desktop`} renderAs="span">
                      <div style={{ minWidth: 80 }} dangerouslySetInnerHTML={{ __html: chordHtml }} />
                    </Heading>
                  </Level.Item>
                  <Level.Item>
                  <Button
                    color=""
                    renderAs="span"
                    marginless={true}
                    size={'small'}
                    onClick={() => pasteTemplateBelow()}
                    >
                    <b>&lt;&gt;</b>
                  </Button>

                    <Input domRef={belowRef} size={'small'} style={{ minWidth: 400 }}  onChange={(e) =>  {setValue(e); setCursor('pointer');}} name="b" type="text" placeholder="Text below chord" value={mark?.b ?? ""} />
                  </Level.Item>
                  <Level.Item>
                    <Button.Group hasAddons={true}>
                      <Button size={'small'} style={{backgroundColor: chordColors.r}} renderAs="span" onClick={() => setColor('r')} status={mark?.bc === 'r'?'active':''}>
                        &nbsp;
                      </Button>
                      <Button size={'small'} style={{backgroundColor: chordColors.g}} renderAs="span" onClick={() => setColor('g')} status={mark?.bc === 'g'?'active':''}>
                        &nbsp;
                      </Button>
                      <Button size={'small'} style={{backgroundColor: chordColors.b}} renderAs="span" onClick={() => setColor('b')} status={mark?.bc === 'b'?'active':''}>
                        &nbsp;
                      </Button>
                      <Button size={'small'} style={{backgroundColor: chordColors.c}} renderAs="span" onClick={() => setColor('c')} status={mark?.bc === 'c'?'active':''}>
                        &nbsp;
                      </Button>
                      <Button size={'small'} style={{backgroundColor: chordColors.m}} renderAs="span" onClick={() => setColor('m')} status={mark?.bc === 'm'?'active':''}>
                        &nbsp;
                      </Button>
                      <Button size={'small'} style={{backgroundColor: chordColors.y}} renderAs="span" onClick={() => setColor('y')} status={mark?.bc === 'y'?'active':''}>
                        &nbsp;
                      </Button>
{/*                       <Button size={'small'} style={{backgroundColor: chordColors.o}} renderAs="span" onClick={() => setColor('o')} status={mark?.bc === 'o'?'active':''}>
                        &nbsp;
                      </Button> */}
                      <Button size={'small'} style={{backgroundColor: chordColors.w}} renderAs="span"  onClick={() => setColor('')} status={!mark?'active':''}>
                        &nbsp;
                      </Button>
                    </Button.Group>
                  </Level.Item>
                  <Level.Item>
                    <Checkbox onChange={(e) => {setValue(e, 'Boolean'); setCursor('pointer');}} name="to" checked={mark?.to === true}>
                      <span style={{ fontWeight: 900, color: 'blue' }}>→</span>
                    </Checkbox>
                  </Level.Item>
                  <Level.Item>
                  <Button.Group >
                      <Button size={'small'} renderAs="span" color={'danger'} onClick={clearMark}>
                        Clear
                      </Button><Button onClick={() => setCursor('pointer')} size={'small'} renderAs="span" status={cursor==='pointer'?'active':''}>
                        <Icon><FontAwesomeIcon icon={faHandPointer} /></Icon>
                      </Button>
                      <Button onClick={() => setCursor('roller')} size={'small'} renderAs="span" style={{backgroundColor: chordColors[mark?.bc]}} status={cursor==='roller'?'active':''}>
                        <Icon><FontAwesomeIcon icon={faPaintRoller} /></Icon>
                      </Button>
                    </Button.Group>
                  </Level.Item>
                </Level.Side>
              </Level>
            </Box>
          </Navbar.Container>
          <Navbar.Container align='right'>
            <Box>
              <Level>
                <Level.Side align="right">
                  <Level.Item>
                    <Button  size={'small'} color="danger" type="button" onClick={clearAllMarks}>Clear all</Button>
                  </Level.Item>
                </Level.Side>
              </Level>
            </Box>
          </Navbar.Container>
        </Navbar.Menu>
      </Navbar>
    </>
  )
});

export default ScoreMarks;